module.exports = __webpack_public_path__ + "static/media/banana_temp.2ccc6a30.png";